
export default {
    name: 'line-row',
    props: {
      height: {
          type: [String, Number],
          default: 16
      },
        background: {
            type: String,
            default: 'transparent'
        }
    },
    computed: {
        heightRem() {
            // 效果图以360尺寸为基准
            return this.height * 1 / 36;
        }
    },
    render() {
        return (
          <div>
              <div {...{
                    class: 'line-row',
                    style: {
                        height: `${this.heightRem}rem`,
                        background: this.background
                    }
              }}></div>
          </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/line-row.vue